import { queryOptions } from '@tanstack/react-query';

import rtwClient from '../apiService';

import TaskService from './taskService';

// **** Queries **** //

export const getTaskQueryOptions = {
  nonPhysicalTasks: () =>
    queryOptions({
      queryKey: ['nonPhysicalTasks'] as const,
      queryFn: () => TaskService.fetchNonPhysicalTasks(),
    }),
  nonPhysicalTasksByRegion: (regionId: number) =>
    queryOptions({
      queryKey: ['nonPhysicalTasks', 'regions', regionId] as const,
      queryFn: () => TaskService.fetchNonPhysicalTasksByRegion(regionId),
    }),
  regionTaskGroups: (regionId: number) =>
    queryOptions({
      queryKey: ['regionTaskGroups', regionId],
      queryFn: () => TaskService.getRegionGroupsAndTasksByRegionId(regionId, rtwClient),
    }),
  regionTasks: (regionId: number) =>
    queryOptions({
      queryKey: ['regionTasks', regionId],
      queryFn: () => TaskService.fetchRegionTasksByRegionId(regionId, rtwClient),
    }),
};

// **** Mutations **** //

export const getTaskMutationOptions = {
  nonPhysicalTasks: {
    create: () => ({
      mutationFn: TaskService.createNonPhysicalTask,
      meta: {
        invalidates: [getTaskQueryOptions.nonPhysicalTasks().queryKey],
        successMessage: 'Created Non-Physical Task successfully',
      },
    }),
    update: () => ({
      mutationFn: TaskService.updateNonPhysicalTask,
      meta: {
        invalidates: [getTaskQueryOptions.nonPhysicalTasks().queryKey],
        successMessage: 'Saved Non-Physical Task successfully',
      },
    }),
    delete: () => ({
      mutationFn: TaskService.deleteNonPhysicalTask,
      meta: {
        invalidates: [getTaskQueryOptions.nonPhysicalTasks().queryKey],
        successMessage: 'Deleted Non-Physical Task successfully',
      },
    }),
  },
};
